import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ModuleTrackerService {
  private activeModule: string = 'image'; // Default to image module for backward compatibility

  constructor() {}

  /**
   * Set the currently active module
   * @param module The module name (image, text, video)
   */
  setActiveModule(module: string): void {
    this.activeModule = module;
  }

  /**
   * Get the currently active module
   * @returns The active module name
   */
  getActiveModule(): string {
    return this.activeModule;
  }
} 